export type PriceFormatterOptions = {
	currency?: string;
	decimalPlaces?: number;
	thousandSeparator?: string;
	decimalSeparator?: string;
	symbolPosition?: 'before' | 'after';
}

export type CurrencyDetailsType = {
	[key: string]: { symbol: string; position: 'after' | 'before' };
}

export const priceFormatter = (price: number | undefined, options = {} as PriceFormatterOptions) => {
	if (price === undefined) return "Nincs ár"

	const currencyDetails: CurrencyDetailsType = {
			EUR: { symbol: '€', position: 'after' },
			USD: { symbol: '$', position: 'before' },
			JPY: { symbol: '¥', position: 'before' },
			BGN: { symbol: 'лв', position: 'after' },
			CZK: { symbol: 'Kč', position: 'after' },
			DKK: { symbol: 'kr', position: 'after' },
			GBP: { symbol: '£', position: 'before' },
			HUF: { symbol: 'Ft', position: 'after' },
			PLN: { symbol: 'zł', position: 'after' },
			RON: { symbol: 'lei', position: 'after' },
			SEK: { symbol: 'kr', position: 'after' },
			CHF: { symbol: 'CHF', position: 'after' },
			NOK: { symbol: 'kr', position: 'after' },
			HRK: { symbol: 'kn', position: 'after' },
			RUB: { symbol: '₽', position: 'after' },
			TRY: { symbol: '₺', position: 'before' },
			AUD: { symbol: 'A$', position: 'before' },
			BRL: { symbol: 'R$', position: 'before' },
			CAD: { symbol: 'C$', position: 'before' },
			CNY: { symbol: '¥', position: 'before' },
			HKD: { symbol: 'HK$', position: 'before' },
			IDR: { symbol: 'Rp', position: 'before' },
			ILS: { symbol: '₪', position: 'before' },
			INR: { symbol: '₹', position: 'before' },
			KRW: { symbol: '₩', position: 'before' },
			MXN: { symbol: '$', position: 'before' },
			MYR: { symbol: 'RM', position: 'before' },
			NZD: { symbol: 'NZ$', position: 'before' },
			PHP: { symbol: '₱', position: 'before' },
			SGD: { symbol: 'S$', position: 'before' },
			THB: { symbol: '฿', position: 'before' },
			ZAR: { symbol: 'R', position: 'before' }
	};

	const {
			currency = 'HUF',         // Alapértelmezett valuta
			decimalPlaces = 0,        // Alapértelmezett tizedesjegyek száma
			thousandSeparator = ' ',  // Ezerelválasztó jel
			decimalSeparator = '.',   // Tizedeselválasztó jel
			symbolPosition            // Valutajel pozíciója: 'before' vagy 'after' (opcionális, felülírja az alapértelmezettet)
	} = options;

	const currencyDetail = currencyDetails[currency] || { symbol: currency, position: 'after' };
	const position = symbolPosition || currencyDetail.position;

	// Az ár tizedesjegyekre kerekítése
	let formattedPrice = Number(price).toFixed(decimalPlaces);

	// Tizedesjegyek és egész rész szétválasztása
	const parts = formattedPrice.split('.');
	let integerPart = parts[0];
	const decimalPart = parts[1] || '';

	// Ezerelválasztó hozzáadása
	integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);

	// Tizedes elválasztó hozzáadása
	formattedPrice = integerPart;
	if (decimalPlaces > 0) {
			formattedPrice += decimalSeparator + decimalPart;
	}

	// Valutajel hozzáadása a megfelelő pozícióba
	const currencySymbol = currencyDetail.symbol;
	if (position === 'before') {
			formattedPrice = currencySymbol + ' ' + formattedPrice;
	} else {
			formattedPrice += ' ' + currencySymbol;
	}

	return formattedPrice;
}